import { PurchaseButton } from "./PurchaseButton";
import usePurchase, { PRIMARY_PRICE_DISPLAY } from "@/hooks/usePurchase";

export default function MobileSticky() {
  const { purchase, loading } = usePurchase();
  return (
    <div
      data-testid="mobile-sticky-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-50 px-3 pb-3 pt-2 bg-gradient-to-t from-black via-black/95 to-black/0"
    >
      <div className="backdrop-blur-xl bg-black/80 border border-emerald-500/30 rounded-2xl p-2.5 shadow-[0_0_40px_-5px_rgba(16,185,129,0.5)]">
        <PurchaseButton
          testId="mobile-sticky-purchase-btn"
          onClick={() => purchase()}
          loading={loading}
          size="md"
          fullWidth
          label={`Purchase Now — ${PRIMARY_PRICE_DISPLAY}`}
        />
      </div>
    </div>
  );
}
